import {inject, Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {Subscription} from "../../models/subscription.model";
import {ApiRoutesService} from "../api-routes.service";
import {PageModel} from "../../models/page.model";
import {SortDirection} from "@angular/material/sort";

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  readonly #httpClient = inject(HttpClient);
  readonly #apiRoutes = inject(ApiRoutesService);

  public findAll(page: number, pageSize: number, search: string, sort: string, direction: SortDirection): Observable<PageModel<Subscription>> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString())
      .set('search', search)
      .set('sort', sort)
      .set('direction', direction);

    return this.#httpClient.get<PageModel<Subscription>>(this.#apiRoutes.subscription(), {params});
  }

  public findAllActive(page: number, pageSize: number, search: string, sort: string, direction: SortDirection): Observable<PageModel<Subscription>> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString())
      .set('search', search)
      .set('sort', sort)
      .set('direction', direction);
    return this.#httpClient.get<PageModel<Subscription>>(this.#apiRoutes.subscription() + '/active', {params});
  }
}
